/*** 
 * 描述：系统公共main组件
 */
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwRightClickMenuComponent } from 'src/app/librarys/components/app-components/sw-right-click-menu/sw-right-click-menu.component';
import { environment } from 'src/environments/environment';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $: any;

@Component({
  selector: 'sw-main',
  templateUrl: './sw-main.component.html',
  styleUrls: ['./sw-main.component.css']
})
export class SwMainComponent implements OnInit {

  @ViewChild("Tabmenu") Tabmenu: SwRightClickMenuComponent //右键菜单

  menuList: Array<{ title: string, Path: string, isSelect: boolean }> = [];

  //该项目是支持单页签还是支持多页签， 为false是支持多页签， 为true是支持单页签
  singleTab:boolean

  //当 singleTab 值为true时， 即支持单页签时，获取当前激活标签页， 只显示此页签
  activeMenu:any

  defaultPortal:string  //默认的首页
  hideSingleTab:string  //隐藏单页签的页面集
  //当全局订阅的菜单MenuTab发生改变时，用当前变量代表变化后的所有菜单集合
  menu:any; 
  //tab是否显示上一个、下一个按钮
  isbtn: boolean = false;

  crumbs:any[] = []  //面包屑数组
  crumbsLast:any   //面包屑数组的最后一个对象，即当前菜单
  areas:any[] = []  //单页签模式下，当前模块信息
  parent:any[] = []  //单页签模式下，当前菜单的所有父级菜单

  singleTabSubscriptiona:any  //单页签订阅对象
  menuTabValueSubscriptiona1:any  //菜单订阅对象
  menuTabValueSubscriptiona2:any  //菜单订阅对象
  constructor(
    private MenuTab: SwRouteguardService, //路由服务
    private swtab: SwTabService, //tab 页面服务
    private el:ElementRef,
    private Const:SwMenuService, //菜单服务
    private box: SwMassageBoxService, //提示框服务
    private router: Router
    ) {
  }

  ngOnDestroy(): void {
    if(this.singleTabSubscriptiona){
      this.singleTabSubscriptiona.unsubscribe()  //取消订阅
    }
    if(this.menuTabValueSubscriptiona1){
      this.menuTabValueSubscriptiona1.unsubscribe()  //取消订阅
    }
    if(this.menuTabValueSubscriptiona2){
      this.menuTabValueSubscriptiona2.unsubscribe()  //取消订阅
    }
  }

  ngOnInit() {
    this.defaultPortal = environment.defaultPortal  //获取默认首页路径
    this.hideSingleTab = environment.hideSingleTab  //获取隐藏单页签的页面
    
    //该项目是支持单页签还是支持多页签， 为false是支持多页签， 为true是支持单页签
    this.singleTab = environment.singleTab
    //获取菜单
    this.menuList = this.MenuTab.getMenus();
    //如果只支持单页签，就获取当前的页签信息
    if(this.singleTab && this.menuList.length){
      this.activeMenu = this.menuList.filter(item => item.isSelect == true)[0]
    } else {
      // 如果最开始的menuList是空数组， 那就显示默认的工作台， 但是工作台的Title不确定， 先暂时设置为  {Title:"首页"} ， 下面订阅tab栏菜单之后会更新
      this.activeMenu = {path: environment.defaultPortal, isSelect: true, queryParams: {Title:"首页"}}
    }
    //单页签模式下，找到当前模块和菜单，显示在面包屑中
    if(this.singleTab){
      this.singleTabSubscriptiona = this.Const.singleTabUpdated.subscribe(data=>{
        //每当路由发生变化时
        this.areas = []
        this.areas.push(this.Const.getMenusVal())
        //看当前菜单是否在当前模块中存在，如果存在，就加上以及当前菜单的父级
        this.crumbsLast = null
        this.findActiveMenu(this.areas,this.activeMenu.path)  //先根据模块和当前菜单信息，找到当前菜单在模块信息中对应的数据，放在 面包屑 数组中
        if(this.crumbsLast){  //如果在模块中能找到当前菜单，就更新面包屑，否则就沿用上次的面包屑  
          this.crumbs = [this.crumbsLast]
          //如果能找到当前菜单，再去根据当前菜单找到它的所有父级
          this.parent = []
          this.findParent(this.areas,this.crumbs[0])  
          if(this.parent.length){  // [父级，父级的父级，父级的父级的父级]
            //先翻转这个父级的数组
            this.parent = this.parent.reverse()
            //然后将首页加到数组的最前面，当前菜单加到数组的最后面
            this.parent.unshift({ functionName: "首页", uri:environment.defaultPortal})
            this.crumbs = this.parent.concat(this.crumbs)
          }
        }
      })
      
    }
    //订阅菜单
    this.menuTabValueSubscriptiona1 = this.MenuTab.valueUpdated.subscribe((val) => {
      this.menuList = val
      //如果只支持单页签，就获取当前的页签信息, 且获取tab栏右侧导航信息
      if(this.singleTab){
        this.activeMenu = this.menuList.filter(item => item.isSelect == true)[0]
        //将 this.menuList 中的之前的页签都要关闭， 避免提示标签开启过多
        this.menuList = this.menuList.filter(item=>item.isSelect)
        //修改完 this.menuList 之后，要将 路由守卫文件中的 this.menuList 更新一下
        // 这样点击新标签的时候 ， 路由守卫文件中的 this.menuList一开始永远只有两个， 不会超出数量
        this.MenuTab.setMenu(this.menuList)
        //重新发布,此时路由复用已经失效，所以不用删除路由缓存， 而且也不要发布新的 this.menuList ， 不然又会触发现在这个订阅的方法，无限循环
      }
    })
  }
  ngAfterViewInit(): void {
    this.menuTabValueSubscriptiona2 = this.MenuTab.valueUpdated.subscribe((val) => {
      //全局订阅的菜单发生变化，将值赋值给menu
      this.menu = val;
      if(!this.singleTab){
        //如果是多页签模式
      //需要定时器（若没有定时器，页面菜单还没渲染完，不能获取对应的ul和li的宽）
      setTimeout(()=>{
        //如果setTabButton()返回的值为true 代表选择的菜单的总宽度大于当前盒子的宽度，上一个和下一个按钮需要显示
        if(this.setTabButton()){
          //判断是否为最后一个选中状态（即判断是否为新增的菜单，若为新增的菜单，需要移动到最后一个tab）
          let menuLast = this.menu[this.menu.length-1]
          if(menuLast['isSelect']){
            //移动到最后一个tab
            this.moveToLastTabItem ()
          }else {
            let index = this.menu.findIndex(item=>item['isSelect'] == true)
           // 如参数为true 则是从菜单后面开始移动
           if(this.moveToPrevTabItem(true,index)){
            let arr = [...this.menu];
            let arr1 = arr.reverse(); //数组反转
            let index1 = arr1.findIndex(item=>item['isSelect'] == true)
            this.moveToNextTabItem(true,index1)
           }
          }
        } 
       },100)
      }
    })
  }
  //设置tab(当header点击toggle时，向左压缩和向右伸展左侧菜单时，重新设置tab，使其自适应宽度)
  setTab(){
    //因为左侧菜单向左向右压缩和伸展的时间为0.3s 所以设置定时器的延迟时间为0.35s
    setTimeout(()=>{
      //如果setTabButton()返回true 代表当前选择的tab菜单总宽度大于当前盒子的总宽度，上一个和下一个按钮需要显示
      if(this.setTabButton()){
        //判断是否为最后一个选中状态（即判断是否为新增的菜单）
        let menuLast = this.menu[this.menu.length-1]
        if(menuLast['isSelect']){
           //移动到最后一个tab
          this.moveToLastTabItem ()
        }
      }
     },350)
  }
  //关闭tab 
  closeUrl(Path: string, isSelect: boolean) {
    this.swtab.closeUrl(Path, isSelect);
    //找到显示的那个标签,改变地址栏,使之跳转到对应的路由
    let showMenu = this.menuList.filter(item => item.isSelect == true)

  }

  //右键打开菜单
  nomenu(event, menu) {
    event.preventDefault();
    this.Tabmenu.RightMenu(event, menu);

  }
   //设置tab按钮(左和右),显示返回true,隐藏返回false
   setTabButton()
   {
     //获取myMainTabs对象
     let $links = $("#myMainTabs")
     //获取myTab对象
     let $linksUl = $("#myTab")
      //tab的选择菜单总宽度为0
       let sumwidth = 0;
     //遍历tab中所有的已选择菜单
       $("li", $linksUl).each(function ()
       {
         //获取已选择所有菜单的总宽度（因为width()方法不包含改元素的margin值，所以总宽度还需要加上每个li的margin-right值，即14px）
           sumwidth += $(this).width() +14;
       });
       //获取总盒子的宽度
       let mainwidth =$links.width();
      //判断已选择所有菜单的总宽度和当前总盒子的宽度大小，大于当前总盒子时，需要显示上一个和下一个按钮
       if (sumwidth > mainwidth)
       {
         //上一个、下一个按钮显示
           this.isbtn = true;
           //返回值为 true
           return true;
       } else
       {
         //若已选择所有菜单的总宽度小于当前盒子的总宽度，不需要显示上一个、下一个按钮，且ul的left值默认为8px
        $("#myTab").animate({ left: 8 });
           this.isbtn = false;
          //返回值为 false
           return false;
       }
   }

      //切换到上一个tab 按钮： <
      moveToPrevTabItem(isMove:boolean,index:number)
      {
        let $links = $("#myMainTabs")
        let $linksUl = $("#myTab")
          //获取上一个按钮的宽度
          let btnWitdth = $(".l-tab-links-left", $links).width();
          let leftList = new Array(); //记录每个tab的left,由左到右
          //遍历ul下的所有li，即遍历所有的已选择菜单
          $("li", $links).each(function (i, item)
          {
            //当前为第一个菜单，left值为按钮的宽度加上4px(加4px原因：是为了第一个菜单选中时和按钮有一定的距离，为了美观)
              let currentItemLeft = -1 * btnWitdth-4;
              //不为第一个菜单时
              if (i > 0)
              {
                //left值：前一个菜单的left值parseInt(leftList[i - 1]) + 当前菜单的宽度$(this).prev().width() + margin-right值14px - 1px(该1px是为了美观，为了该菜单与按钮的距离)
                  currentItemLeft = parseInt(leftList[i - 1]) + $(this).prev().width() +14-1;
              }
              leftList.push(currentItemLeft);
          });
          //当前ul的left值
          let currentLeft = -1 * parseInt($linksUl.css("left"));
          //在点击菜单时（不是新增的新菜单，而是在比较靠前的菜单，被上一个按钮遮挡的菜单），如果菜单的left值小于当前的ul的left值，需要运动到当前的选中的菜单left值
          if(isMove){
            //点击菜单 符合条件移动
            if(leftList[index] < currentLeft){
              $linksUl.animate({ left: -1 * parseInt(leftList[index]) });
              return false;
            }else {
              return true;
            }

          }else {
            //点击上一个按钮移动
            for (let i = 0; i < leftList.length - 1; i++)
            {
              //若下标为i的li的left值小于当前的ul的left值，但是下一个li的left值大于当前的ul的left值，即点击上一个时，需要运动到下标的left值小于当前ul的left值的li
                if (leftList[i] < currentLeft && leftList[i + 1] >= currentLeft)
                {
                  $linksUl.animate({ left: -1 * parseInt(leftList[i]) });
                  return false;
                }
            }
          }
        
         
      }

       //切换到下一个tab 按钮：>
       moveToNextTabItem(isMove:boolean,index:number)
       {
        let $links = $("#myMainTabs")
        let $linksUl = $("#myTab")
           //获取下一个按钮的宽度
           let btnWitdth = $(".l-tab-links-right", $links).width();
           let sumwidth = 0;//当前选择的菜单总宽度初始值
           let tabItems = $("li", $linksUl);
           //遍历所有的li
           tabItems.each(function ()
           {
             //获取菜单的总宽度（14px:为li的margin-right值）
               sumwidth += $(this).width() +14;
           });
           //获取总盒子的宽度
           let mainwidth = $links.width();
           let leftList = new Array(); //记录每个tab的left,由右到左 
           for (let i = tabItems.length - 1; i >= 0; i--)
           {
             //获取最后一个菜单的left值：其中22代表（为了页面美观，使其最后一个菜单离右边下一个按钮的距离减小）
              let currentItemLeft = sumwidth - mainwidth + btnWitdth-22; //最后一个
              //不是最后一个
               if (i != tabItems.length - 1)
               {
                 //14px:不仅要减去下一个宽度，还有其margin值
                   currentItemLeft = parseInt(leftList[tabItems.length - 2 - i]) - $(tabItems[i + 1]).width() -14;
               }
               leftList.push(currentItemLeft);
           }
           let currentLeft = -1 * parseInt($linksUl.css("left"));
            //在点击菜单时（不是新增的新菜单，而是在比较靠后的菜单，被下一个按钮遮挡的菜单），如果菜单的left值大于当前的ul的left值，需要运动到当前的选中的菜单left值
           if(isMove){
             //点击菜单 符合条件移动
             if(leftList[index] > currentLeft){
              $linksUl.animate({ left: -1 * parseInt(leftList[index]) });
              return;
             }
           }else {
            for (let j = 1; j < leftList.length; j++)
            {
                //若下标为j的li的left值小于等于当前的ul的left值，但是上一个li的left值大于当前的ul的left值，即点击下一个时，需要运动到下标的left值大于当前ul的left值的li
                if (leftList[j] <= currentLeft && leftList[j - 1] > currentLeft)
                {
                 $linksUl.animate({ left: -1 * parseInt(leftList[j - 1]) });
                    return;
                }
            }
           }
          
       }

         //移动到最后一个tab
      moveToLastTabItem ()
      {
        let $links = $("#myMainTabs")
        let $linksUl = $("#myTab")
        //当前选择的菜单总宽度初始值
          let sumwidth = 0;
          //遍历所有li
          $("li", $linksUl).each(function ()
          {
             //获取菜单的总宽度（14px:为li的margin-right值）
              sumwidth += $(this).width()  +14;
          });
          //获取总盒子的宽度
          let mainwidth = $links.width();
          //大于
          if (sumwidth > mainwidth)
          {
             //下一个按钮的宽度
              let btnWitdth = $(".l-tab-links-right", $links).width();
              //如果页面还没加载出来，给个默认宽度
              if(!btnWitdth){
                btnWitdth = 17;
              }
              //滑动到最后一个
              $linksUl.animate({ left: -1 * (sumwidth - mainwidth + btnWitdth-22) });
          }
      }


  /**
   * 根据 key 值，找到它在 tree 中对应的值，并将之返回
   * @param tree 
   * @param key 
   */
  findActiveMenu(tree,key){
    for (let i = 0; i < tree.length; i++) {
      if(tree[i]['uri'] == key){
        //菜单树中找到当前菜单对应的路径
        this.crumbsLast = tree[i]
      }
      if(tree[i]['children'] && tree[i]['children']['length']){
        this.findActiveMenu(tree[i]['children'],key)
      }
      
    }
  }

  /**
   * 根据节点找到其所有的父节点，放在 this.parent 数组中
   * @param menus 要处理的数组
   * @ignore
   */
  findParent(tree,node){
    if(node.parentId){
      //找到该节点的所有父级
      for (let i = 0; i < tree.length; i++) {
        if(tree[i].functionId == node.parentId){  //找到了该节点的父级，如果父级还有父级，就继续找
          this.parent.push(tree[i])  //找到了父级
          if(tree[i]['parentId']){
            this.findParent(this.areas,tree[i])
          }
        }
        if(tree[i]['children'] && tree[i]['children']['length']){  //还有子级就递归处理
          this.findParent(tree[i]['children'],node)
        }
      }
    }
  }

  /**
   * 点击跳转
   * @param event 
   */
  toUri(item){
    if(item.uri && item.uri != '#'){
      this.router.navigate([item.uri], {
        queryParams: { Title: item.functionName},
      });
    } else {
      this.box.danger('无跳转路径')
    }
  }
}
